var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{class:['size-' + _vm.size, _vm.iconClass],domProps:{"innerHTML":_vm._s(_vm.iconSvg(_vm.name))}})
}
var staticRenderFns = []

export { render, staticRenderFns }